import type { JSX } from 'react';

import { Translate, TranslateHtml } from '@change-corgi/core/react/i18n';
import { Separator } from '@change-corgi/design-system-legacy/components/content';
import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { useRecentSupportersList } from './hooks/useRecentSupportersList';

export function RecentSupportersList(): JSX.Element {
	const { data, actions } = useRecentSupportersList();

	return (
		<>
			<Flex p="24px 24px 16px" sx={{ alignItems: 'center', gap: 4 }}>
				<Heading as="h3" size="h4" id="recent-supporters-title">
					<Translate value="corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.title" />
				</Heading>
				<InfoTooltip aria-describedby="recent-supporters-title">
					<Translate value="corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.tip" />
				</InfoTooltip>
			</Flex>
			<Separator />
			<Box
				as="ul"
				role="list"
				sx={{
					height: 144,
					overflow: 'auto',
					flex: '1 1 auto',
					background: 'linear-gradient(to top, lightGrey, transparent 25%)',
				}}
				onScroll={actions.onScrollSupporters}
				data-testid="recent-supporters-list"
			>
				{data.recentSupporters.map((supporter) => (
					<Flex
						as="li"
						role="listitem"
						px={24}
						py={6}
						sx={{ alignItems: 'center', minHeight: '48px', width: '100%' }}
						key={supporter.uniqueKey}
					>
						<Avatar alt="avatar" size="xs" src={supporter.photo} variant="subtle" />
						<Text as="p" ml="8px">
							<Text as="span">
								<TranslateHtml
									value="corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.name_with_sign_time"
									replacements={{
										name: supporter.displayName,
										relative_time: supporter.relativeTimestamp,
									}}
								/>
							</Text>
						</Text>
					</Flex>
				))}
			</Box>
		</>
	);
}
